module.exports = __webpack_public_path__ + "assets/img/img-lecturer-detail.fe6ad7a5.png";